import React, { useState, useEffect } from 'react';
import logo from './logo.png';
import { Typography, Container, Grid, Box, MenuItem, TextField, Select } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Button from '@mui/material/Button';
import whats from './whatsapplogo.png';

// Componente Modal adaptado para ser más grande
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fondo semitransparente para el overlay
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 1, // Bordes redondeados
          backgroundColor: '#DDDDDD',
          maxWidth: '90vw', // Ancho máximo más grande
          maxHeight: '90vh', // Alto máximo más grande
          overflow: 'hidden', // Oculta cualquier contenido que se desborde
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)', // Sombra para mejor contraste
        }}
      >
        <Box
          sx={{
            p: 2,
          }}
        >
          {/* Asumiendo que children es una imagen */}
          {React.cloneElement(children, {
            style: {
              width: '100%', // Asegura que la imagen no exceda el ancho del contenedor
              height: 'auto', // Ajusta la altura automáticamente para mantener la relación de aspecto
              display: 'block', // Evita cualquier margen extra alrededor de la imagen
              objectFit: 'contain', // Mantiene la relación de aspecto sin recortar
              maxHeight: '80vh', // Altura máxima para la imagen más grande
              margin: '0 auto', // Centra la imagen horizontalmente
              backgroundColor: 'red',
            },
          })}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2,
            backgroundColor: '#bbbbbb',
          }}
        >
          <Button 
            onClick={onClose} 
            sx={{ 
              bgcolor: '#DDDDDD', 
              color: '#000000', 
              "&:hover": {
                backgroundColor: "#00470f",
                color: '#ffffff',
              },
            }}
          >
            Cerrar
          </Button>
        </Box>
      </Box>
    </Box>
  );
};




const FormularioLote = ({ lote, currencySymbol, moneda, onCancelar, obtenerUrlImagenManzana }) => {

  let idManzana = lote.Manzana;
  const urlImagenManzana = obtenerUrlImagenManzana(idManzana);

  const [isModalManzanaOpen, setIsModalManzanaOpen] = useState(false);
  const [imagenModalManzana, setImagenModalManzana] = useState(urlImagenManzana);
  const [porcentajes, setPorcentajes] = useState([]); // initialize porcentajes state
  const [numeroCuotas, setNumeroCuotas] = useState(0);
  const [cuotasCalculadas, setCuotasCalculadas] = useState(false); // initialize porcentajes state
  
  const phoneNumber = '5492984144403'; // Número en formato internacional
  const message = 'Hola, me gustaría obtener más información.'; // Mensaje inicial
  const urlEncodedText = encodeURIComponent(message);

  const iconStyleW = {
    width: "30px",
    marginRight: "1px",
    cursor: "pointer",
    height: '20%', // ajusta según sea necesario
    marginLeft: '0px',
  };

  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    tipoPago: '',
    importeAnticipo: '',
    numeroCuotas: '',
    montoCuota: '',
    montoReserva:'',
    cuotasCalculadas: '',
    tipoDocumento: '',
    documento: '',
    direccion: '',
    telefono: '',
    moneda:moneda
  });

  const abrirModalManzana = (idManzana) => {
    setIsModalManzanaOpen(true);
  };


  const enviarReserva = async () => {
    const url = 'https://propietarios.pueblonuevo.com.ar/backendvalle/grabaReserva';
    
    const datosReserva = {
      nombre: formData.nombre,
      nroDoc: formData.documento,
      tipoDocumento: formData.tipoDocumento,
      direccion: formData.direccion,
      telCelu: formData.telefono,
      email: formData.email,
      lote: lote,
      moneda: moneda
    };

    // Verificación de que todos los campos estén completos
    for (const [key, value] of Object.entries(datosReserva)) {
      if (!value) {
        if (key === 'moneda') {
          alert('Por favor, vuelva a la página de inicio y seleccione el lote nuevamente.');
        } else {
          const fieldNames = {
            nombre: 'Nombre',
            nroDoc: 'Documento',
            tipoDocumento: 'Tipo de Documento',
            direccion: 'Dirección',
            telCelu: 'Teléfono',
            email: 'Email',
            lote: 'Lote',
            moneda: 'Moneda'
          };
          alert(`Falta completar el campo: ${fieldNames[key]}`);
        }
        return; // Detiene el envío si algún campo está incompleto
      }
    }

    try {
      const respuesta = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosReserva),
      });
  
      const resultado = await respuesta.json();
      if (resultado.error) {
        alert('Reserva no realizada: ' + resultado.error + " Intenta con otro lote!.");
      } else {
        alert('Reserva enviada con éxito - En unos minutos recibirá el cupón de pago en su correo. Bienvenido a Loteo Valle Manzano');
        onCancelar(); // Asegúrate de que esta función haga lo que esperas (como limpiar el formulario o redireccionar)
      }
      // Aquí puedes manejar la lógica post-envío exitoso, como redireccionar o limpiar el formulario
    } catch (error) {
      console.error('Error al enviar la reserva:', error);
      alert('Error al enviar la reserva. Por favor, inténtalo de nuevo.');
    }
  };


  
  

  useEffect(() => {
    if (formData.tipoPago === 'Contado') {
      setFormData(prev => ({
        ...prev,
        cuotasCalculadas: false,
        montoCuota: '0.00',
        montoReserva: lote.Precio * 1 / 100,
      }));
    }
  }, [formData.tipoPago]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));

      // Si se selecciona un tipo de pago, se establece el número de cuotas desde la respuesta
    if (name === 'tipoPago') {
      const selectedPorcentaje = porcentajes.find(p => p.Denominacion === value);
      if (selectedPorcentaje) {
        setNumeroCuotas(selectedPorcentaje.cuotas);  // Establecer el número de cuotas
      }
    }

    setCuotasCalculadas (false);
  };

  const calcularCuotas = () => {
    let precioFinal = lote.Precio;
    let bonificacion = 0;
    let montoCuotaCalculado = 0;
    let porcentajeMinimo = 0;
    let porcentajeBonificacion = 0;
    let anticipo =0;

    if (formData.tipoPago === 'Anticipo+Cuotas') {
      porcentajeMinimo = porcentajes.find(p => p.Denominacion === 'Anticipo+Cuotas').minimo;
      porcentajeBonificacion = porcentajes.find(p => p.Denominacion === 'Anticipo+Cuotas').bonificacion;
      anticipo = parseFloat(formData.importeAnticipo || 0);
      if ((anticipo <= 0) && (formData.tipoPago === 'Anticipo+Cuotas' )) {alert('El anticipo debe ser mayor a cero'); return;}
      if ((anticipo <= lote.Precio * porcentajeMinimo / 100) && (formData.tipoPago === 'Anticipo+Cuotas' )) {
        let montoFormateado = (lote.Precio * porcentajeMinimo / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        alert('El anticipo debe ser mayor o igual al ' + porcentajeMinimo + '% del precio (' + currencySymbol + montoFormateado + ')');
        return;
        }
    
      bonificacion = anticipo * porcentajeBonificacion / 100;
      precioFinal = lote.Precio - bonificacion - parseFloat(formData.importeAnticipo || 0);
      montoCuotaCalculado = precioFinal / parseInt(formData.numeroCuotas, 10);
    }
    if (formData.tipoPago === 'Contado') {
      porcentajeMinimo = porcentajes.find(p => p.Denominacion === 'Contado').minimo;
      porcentajeBonificacion = porcentajes.find(p => p.Denominacion === 'Contado').bonificacion;
      bonificacion = lote.Precio * porcentajeBonificacion / 100;
      precioFinal = lote.Precio - bonificacion;
    }
    if (formData.tipoPago === 'CUOTAS - 100% FINANCIADO') {
      porcentajeMinimo = porcentajes.find(p => p.Denominacion === 'CUOTAS - 100% FINANCIADO').minimo;
      porcentajeBonificacion = porcentajes.find(p => p.Denominacion === 'CUOTAS - 100% FINANCIADO').bonificacion;
      bonificacion = lote.Precio * porcentajeBonificacion / 100;
      precioFinal = lote.Precio - bonificacion;
      montoCuotaCalculado = precioFinal / parseInt(formData.numeroCuotas, 10);
    }
    if (formData.tipoPago === 'Anticipo+Cuotas') {
      porcentajeMinimo = porcentajes.find(p => p.Denominacion === 'Anticipo+Cuotas').minimo;
      porcentajeBonificacion = porcentajes.find(p => p.Denominacion === 'Anticipo+Cuotas').bonificacion;
      anticipo = parseFloat(formData.importeAnticipo || 0);
      if ((anticipo <= 0) && (formData.tipoPago === 'Anticipo+Cuotas' )) {alert('El anticipo debe ser mayor a cero'); return;}
      if ((anticipo <= lote.Precio * porcentajeMinimo / 100) && (formData.tipoPago === 'Anticipo+Cuotas' )) {
        let montoFormateado = (lote.Precio * porcentajeMinimo / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        alert('El anticipo debe ser mayor o igual al ' + porcentajeMinimo + '% del precio (' + currencySymbol + montoFormateado + ')');
        return;
        }
    
      bonificacion = anticipo * porcentajeBonificacion / 100;
      precioFinal = lote.Precio - bonificacion - parseFloat(formData.importeAnticipo || 0);
      montoCuotaCalculado = precioFinal / parseInt(formData.numeroCuotas, 10);
    }
    if (formData.tipoPago === '70/30') {
      porcentajeMinimo = porcentajes.find(p => p.Denominacion === '70/30').minimo;
      porcentajeBonificacion = porcentajes.find(p => p.Denominacion === '70/30').bonificacion;
      anticipo = parseFloat(lote.Precio * porcentajeMinimo / 100);
      if ((anticipo < lote.Precio * porcentajeMinimo / 100) && (formData.tipoPago === '70/30' )) {
        let montoFormateado = (lote.Precio * porcentajeMinimo / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        alert('El anticipo debe ser mayor o igual al ' + porcentajeMinimo + '% del precio (' + currencySymbol + montoFormateado + ')');
        return;
        }
    
      bonificacion = lote.Precio * porcentajeBonificacion / 100;
      precioFinal = lote.Precio - bonificacion - anticipo;
      montoCuotaCalculado = precioFinal / parseInt(formData.numeroCuotas, 10);
    }
    setCuotasCalculadas (true);
    setFormData(prev => ({
      ...prev,
      anticipo: anticipo,
      porcentajeMinimo: porcentajeMinimo,
      porcentajeBonificacion: porcentajeBonificacion,
      bonificacion:bonificacion,
      precioFinal: precioFinal,
      montoCuota: montoCuotaCalculado.toFixed(2),
      montoReserva: lote.Precio * 1 / 100,
      cuotasCalculadas: formData.numeroCuotas,
      montoCuotaCalculado: montoCuotaCalculado,
      moneda:moneda,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Verificar que ningún campo obligatorio esté vacío
    if (!formData.nombre.trim() || !formData.email.trim() || !formData.documento.trim() || !formData.direccion.trim() || !formData.telefono.trim()) {
      alert('Por favor, completa todos los campos obligatorios.');
      return; // Detiene la función si algún campo obligatorio está vacío
    }

    // Validar el formato del email
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regexEmail.test(formData.email)) {
      alert('Por favor, introduce un email válido.');
      return; // Detiene la función si el email no es válido
    }
    await enviarReserva();

  };

  useEffect(() => {
    const fetchData = async () => {
      if (moneda == null) {
        console.log("No se realiza el fetch porque moneda es null o undefined");
        return; // Salir temprano si no hay un valor válido para moneda
      }
      try {
        let emprendimiento = 1;
        const response = await fetch(`https://propietarios.pueblonuevo.com.ar/backendvalle/porcentajes`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ moneda, emprendimiento }),
        });
        if (!response.ok) {
          throw new Error("Error en la respuesta del servidor");
        }
        const data = await response.json();
        setPorcentajes(data);
        console.log ("Porc:", data);
      } catch (error) {
        console.error("Error al realizar el fetch:", error);
      }
    };
  
    fetchData();
  }, [moneda]); // Se ejecuta cuando el estado moneda cambia
  

  return (
    <Container maxWidth="xl" sx={{
      minHeight: '100vh', // Asegura que el Container ocupe al menos el 100% de la altura del viewport
      display: 'flex',
      flexDirection: 'column', // Organiza los hijos del Container verticalmente
      justifyContent: 'flex-start', // Centra el contenido verticalmente
      alignItems: 'center', // Centra el contenido horizontalmente
      backgroundImage: 'linear-gradient(to right, #f0f0f0, #DDDDDD)'
    }}>
      {/* Cabezera con logo y título */}
      <Box sx={{
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          p: 2, 
          width:'100%',
          borderRadius: '15px',
          boxShadow: '-4px 4px 10px rgba(0, 0, 0, 0.1)'
        }}>
          <img src={logo} alt="Logo Loteo Valle Manzano" style={{ width: '100px', filter: "invert(100%)", }} />
          <Typography variant="h4" component="h1">
            Loteo Valle Manzano
          </Typography>
          <div>
              <a href={`https://wa.me/${phoneNumber}?text=${urlEncodedText}`} target="_blank" rel="noopener noreferrer">
                  Contacta con nosotros vía WhatsApp  &nbsp;
                  {( <img src={whats} alt="logo" style={{
                    ...iconStyleW,
                  }}/>)}
              </a>
              <br/>Cel: +54 9 2984 144403
          </div>
        </Box>
        <Box component="form" onSubmit={handleSubmit} sx={{ bgcolor: 'transparent',width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2,  }}>
          <Grid container spacing={2} sx={{ bgcolor: '#DDDDDD', width: '100%', mt:'20px'}}>
              <Grid item xs={12} md={4} sx={{ bgcolor: '#DDDDDD', width: '100%',  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', p: 2,boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', }}>
              <Card sx={{ minWidth: 275, bgcolor: '#DDDDDD' }}>
              <CardHeader
                  title= {`Manzana ${idManzana} Lote ${lote.Lote}`}
                />
                <CardContent>
                  <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                  {`Superficie ${lote.Superficie}m²` }
                  </Typography>
                  <Typography variant="h6" component="div">
                  {`Precio ${currencySymbol}  ${parseFloat(lote.Precio).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }
                  </Typography>
                </CardContent>
              </Card>
              <img
                  src={urlImagenManzana}
                  alt={`Manzana ${idManzana}`}
                  style={{
                    cursor: 'pointer', // Cambia el cursor a pointer para indicar que es clickeable
                    width: '380px', height: '380px', boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.50)', marginTop:'5px',
                    objectFit: 'contain', // Mantiene la relación de aspecto
                  }}
                  onClick={abrirModalManzana} // Evento para abrir el modal
                />
              {/*<img src={urlImagenManzana} alt={`Manzana ${idManzana}`} style={{ width: '380px', height: '380px', boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.50)', marginTop:'5px'}} />*/}
              <Modal isOpen={isModalManzanaOpen} onClose={() => setIsModalManzanaOpen(false)}>
                {imagenModalManzana && (
                  <img src={urlImagenManzana} alt={`Plano de la manzana ${imagenModalManzana}`} />
                )}
              </Modal>
              </Grid>
              <Grid item xs={12} md={4} sx={{
                bgcolor: '#DDDDDD',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                p: 2,
                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
              }}>
                <Typography variant="subtitle1" component="h1" gutterBottom sx={{ color: 'black' }}>
                  Simula tu plan de pago
                </Typography>
                <Box sx={{
                  bgcolor: '#DDDDDD',
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  p: 2,
                  gap: 1
                }}>
                  <Typography variant="subtitle1" sx={{ color: 'black' }}>
                    Forma de pago
                  </Typography>
                  <Select
                    name="tipoPago"
                    value={formData.tipoPago}
                    onChange={handleChange}
                    fullWidth
                  >
                    {porcentajes.map((porcentaje) => (
                      <MenuItem key={porcentaje.id} value={porcentaje.Denominacion}>
                        {porcentaje.Denominacion} {porcentaje.bonificacion > 0 ? `(${porcentaje.bonificacion}%)` : ''}
                      </MenuItem>
                    ))}
                  </Select>

                  {formData.tipoPago === 'Anticipo+Cuotas' && (
                    <TextField
                      name="importeAnticipo"
                      label="Importe Anticipo"
                      variant="outlined"
                      value={formData.importeAnticipo}
                      onChange={handleChange}
                      fullWidth
                    />
                  )}
                  {(formData.tipoPago === 'Anticipo+Cuotas' || formData.tipoPago === 'CUOTAS - 100% FINANCIADO' || formData.tipoPago === '70/30') && (
                    <Select
                      name="numeroCuotas"
                      value={formData.numeroCuotas}
                      onChange={handleChange}
                      displayEmpty
                      fullWidth
                    >
                      <MenuItem value="">
                        <em>Seleccione cantidad de cuotas</em>
                      </MenuItem>
                      {[...Array(numeroCuotas).keys()].map(n => (
                        <MenuItem key={n + 1} value={n + 1}>{n + 1}</MenuItem>
                      ))}
                    </Select>
                  )}
                  <Button variant="contained" onClick={calcularCuotas}>
                    Simular plan de pago
                  </Button>
                  {cuotasCalculadas && <Box sx={{ p: 2, bgcolor: 'white', mt: 2, borderRadius: 4, boxShadow: 1 }}>
                    <Typography variant="h6" gutterBottom>
                      <strong>Detalles del plan de pago</strong>
                    </Typography>
                    <Grid container spacing={2}>
                      <>
                          <Grid item xs={12} sm={6}>
                          {formData.tipoPago !== 'Contado' && (<Typography sx={{ fontSize: '12px' }}>
                              <strong>Cuotas:</strong> {formData.cuotasCalculadas}
                            </Typography>
                            )}
                          {formData.tipoPago === 'Contado' && (<Typography sx={{ fontSize: '12px' }}>
                          <strong>Cuotas: N/A</strong> 
                            </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                          {formData.tipoPago !== 'Contado' && (<Typography sx={{ fontSize: '12px' }}>
                              <strong>Monto por Cuota:</strong> {currencySymbol} {parseFloat(formData.montoCuota).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                          )}
                          {formData.tipoPago === 'Contado' && (<Typography sx={{ fontSize: '12px' }}>
                          <strong>Monto por Cuota:</strong> N/A
                              </Typography>
                              )}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: '12px' }}>
                              <strong>Bonificación:</strong> {formData.porcentajeBonificacion}% $ {parseFloat(formData.bonificacion ).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: '12px' }}>
                              <strong>Precio final: {currencySymbol} {parseFloat(formData.precioFinal + formData.anticipo ).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </strong>
                            </Typography>
                          </Grid>
                        </>
                    </Grid>
                  </Box>}
                </Box>
              </Grid>
        
          <Grid item xs={12} md={4} sx={{ bgcolor: '#DDDDDD', width: '100%',  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', p: 2,boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', }}> 
              <Typography variant="subtitle1" component="h1" gutterBottom sx={{color: 'black'}}>
                    Ingrese sus datos
                  </Typography>  
                  <Box item xs={12} md={4} sx={{ bgcolor: '#DDDDDD', width: '90%',  display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start', p: 2, gap:1 }}>            
                  <div className="formulario-field">
                    <input
                      type="text"
                      name="nombre"
                      placeholder="Nombre completo"
                      value={formData.nombre}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="formulario-field">
                    <select name="tipoDocumento" value={formData.tipoDocumento} onChange={handleChange}>
                      <option value="">Tipo de Documento</option>
                      <option value="DNI">DNI</option>
                      <option value="CDI">CDI</option>
                      <option value="Pasaporte">Pasaporte</option>
                    </select>
                  </div>
                  <div className="formulario-field">
                    <input
                      type="text"
                      name="documento"
                      placeholder="Número de Documento"
                      value={formData.documento}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="formulario-field">
                    <input
                      type="text"
                      name="direccion"
                      placeholder="Dirección"
                      value={formData.direccion}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="formulario-field">
                    <input
                      type="text"
                      name="telefono"
                      placeholder="Teléfono"
                      value={formData.telefono}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="formulario-field">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <Box sx={{ 
  display: 'flex', 
  flexDirection: 'row',  // Esto alinea los elementos secundarios en una fila
  justifyContent: 'space-between', // Esto coloca un elemento en cada extremo del contenedor
  alignItems: 'center',  // Esto centra los elementos verticalmente
  width: '100%', 
  mt: 4, // Ajusta este valor para cambiar el espacio superior
}}>
  <Button 
    type="submit" 
    variant="contained"
    sx={{ 
      bgcolor: 'GREEN', 
      color: 'white',
      '&:hover': {
        bgcolor: 'LIGHTGREEN',
        color: 'BLACK',
      },
    }}
  >
    RESERVAR
  </Button>
  <Button 
    variant="outlined"
    onClick={onCancelar} 
    sx={{ 
      bgcolor: 'secondary.main', 
      color: 'white',
      '&:hover': {
        bgcolor: 'secondary.dark',
      },
    }}
  >
    Ver otro lote
  </Button>
  
</Box>
              </Box>
          </Grid>
        </Grid>  
      </Box>
    </Container>
  );
};

FormularioLote.displayName = 'FormularioLote';

export default FormularioLote;
